module.exports = __webpack_public_path__ + "img/切片.91bd1a31.png";